import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { MeasurementResponse } from '@core/interfaces/measurement-response';
import { MeasurementDeviceBaseService } from '@core/services/base/measurement-device-base.service';

@Injectable({
  providedIn: 'root',
})
export class MeasurementDeviceMockService extends MeasurementDeviceBaseService {
  #mockDataChangedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public constructor() {
    super();
    fromEvent(document, 'keypress').subscribe((e: KeyboardEvent) => {
      if (e.key === `s`) {
        setTimeout(() => this.#mockDataChangedSubject.next(true), 1000);
      }
    });
  }

  public dataCaptureStop(): void {
    this.thicknessDataReceived();
  }

  public onDataFrom38DLReceived(): Observable<MeasurementResponse> {
    return new Observable(observer => {
      this.mockDataChanged().subscribe(() => {
        observer.next({ data: Math.random() * 5 });
        setTimeout(() => observer.next({ data: null }), 1000);
      });
    });
  }

  public sendThicknessRequest(): Promise<number> {
    return Promise.resolve(1).then(() => {
      setTimeout(() => this.#mockDataChangedSubject.next(true), 1000);
      return Promise.resolve(1);
    });
  }

  public sendUnitOfMeasurementRequest(): Promise<number> {
    return Promise.resolve(1).then(() => {
      setTimeout(() => this.#mockDataChangedSubject.next(true), 1000);
      return Promise.resolve(1);
    });
  }

  public mockDataChanged(): Observable<boolean> {
    return this.#mockDataChangedSubject;
  }
}
